import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component } from '@angular/core'
import { LeaveSyncDirective } from '@mos/client/shared/utils'
import { HeaderComponent } from '@mos/client/web/core/components/header/header.component'
import { AbstractModalComponent } from '@mos/client/web/core/components/modal/abstract-modal.component'
import { ModalComponent } from '@mos/client/web/core/components/modal/modal.component'

// Short link of this modal's campaign in Ashes and Roses' admin: the store on the phones of its published apps
// (once its OneLink is set up), its site everywhere else
const ASHES_AND_ROSES_LINK = 'https://www.ashesandroses.fr/go/bvHfte'

// Promotes the Ashes and Roses launch to the Memory of Souls players registered before it
@Component({
	selector: 'ashes-and-roses-launch-modal',
	imports: [ModalComponent, HeaderComponent, LeaveSyncDirective, NgOptimizedImage],
	templateUrl: './ashes-and-roses-launch.modal.html',
	styleUrl: './ashes-and-roses-launch.modal.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AshesAndRosesLaunchModal extends AbstractModalComponent {
	public static modalId = 'ashes-and-roses-launch'

	protected readonly link = ASHES_AND_ROSES_LINK

	leave() {
		this.modal()?.close()
	}
}
